import { SearchInput } from "../../ui-kit/SearchInput"
import { AutocompleteInput } from "../../ui-kit/AutocompleteInput"
import { CheckboxInput } from "../../ui-kit/CheckboxInput"
import { GRID_FORM_CONFIG_T } from "../../../common/FormGenerator"
import { TEAMS_FILTRATION } from "../../../consts/formOptions"
import { russiaRegionsOptions } from "../../../consts/russiaRegions"

const teamsRegionOptions = [{ label: 'Все', value: 'all' }, ...russiaRegionsOptions]

export type FiltrationBlockName =
  | "search"
  | "region"
  | "lookingProject"
  | "stage"
  | "enjoyConversation"
  | "availableResources"
  | "conditionsOfParticipation"

export const searchConfig = [
  [
    {
      id: 1,
      controllerName: "search",
      RenderElement: SearchInput,
      renderProps: () => ({
        placeholder: "Поиск...",
        fullWidth: true,
        inputProps: { maxLength: 32 },
      }),
    },
  ],
]

export const regionConfig = [
  [
    {
      id: 2,
      controllerName: "regionTeam",
      RenderElement: AutocompleteInput,
      renderProps: () => ({
        placeholder: "",
        options: teamsRegionOptions,
        fullWidth: true,
      }),
    },
  ],
]

export const lookingProjectConfig = [
  [
    {
      id: 3,
      controllerName: "lookingProject",
      RenderElement: AutocompleteInput,
      renderProps: () => ({
        placeholder: "",
        options: TEAMS_FILTRATION.LOOKING_PROJECT,
        fullWidth: true,
      }),
    },
  ],
]

export const stageConfig = [
  [
    {
      id: 4,
      controllerName: "сompetencies",
      RenderElement: AutocompleteInput,
      renderProps: () => ({
        placeholder: "",
        options: TEAMS_FILTRATION.STAGE,
        fullWidth: true,
      }),
    },
  ],
]

export const enjoyConversationConfig = [
  [
    {
      id: 5,
      controllerName: "newAcquaintances",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Новые знакомства",
      }),
    },
  ],
  [
    {
      id: 6,
      controllerName: "familyLeisure",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Семейный досуг",
      }),
    },
  ],
  [
    {
      id: 7,
      controllerName: "interestClub",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Клуб по интересам",
      }),
    },
  ],
]

export const availableResourcesConfig = [
  [
    {
      id: 8,
      controllerName: "informational",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Информационные",
      }),
    },
  ],
  [
    {
      id: 9,
      controllerName: "labor",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Трудовые",
      }),
    },
  ],
  [
    {
      id: 10,
      controllerName: "financial",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Финансовые",
      }),
    },
  ],
  [
    {
      id: 11,
      controllerName: "transportLogistics",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Транспортно-логистические",
      }),
    },
  ],
  [
    {
      id: 12,
      controllerName: "realEstate",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Недвижимые",
      }),
    },
  ],
]

export const conditionsOfParticipationCongig = [
  [
    {
      id: 13,
      controllerName: "freeOfCharge",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Безвозмездное",
      }),
    },
  ],
  [
    {
      id: 14,
      controllerName: "compensatory",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Возмездное",
      }),
    },
  ],
  [
    {
      id: 15,
      controllerName: "partiallyCompensated",
      RenderElement: CheckboxInput,
      renderProps: () => ({
        label: "Частично-возмездное",
      }),
    },
  ],
]

const formConfigs: Record<FiltrationBlockName, GRID_FORM_CONFIG_T<any>> = {
  search: searchConfig,
  region: regionConfig,
  lookingProject: lookingProjectConfig,
  stage: stageConfig,
  enjoyConversation: enjoyConversationConfig,
  availableResources: availableResourcesConfig,
  conditionsOfParticipation: conditionsOfParticipationCongig,
}

export const getFormConfig = (blockName: FiltrationBlockName) => formConfigs[blockName]